import { regexStringEscape } from "../regex/regexStringEscape.js";
// removes single line comments
export function stringRemoveCustomSingleLineComments(subject, delimiter = '//') {
    // remove comment lines (ex. lines beginning with '//');
    const regex = new RegExp('(?:^|[\\n\\r])\\s*' + regexStringEscape(delimiter) + '[^\\n\\r]*(?=[\\n\\r]+|$)', 'g');
    return subject.replace(regex, '');
}
//# sourceMappingURL=stringRemoveCustomSingleLineComments.js.map